// utilities
import "./utilities/animations";
import "./utilities/lazy-bg";

// lightbox
require('fslightbox');
// import "../../template-parts/blocks/lightbox-video/script";

// components
import "../../template-parts/blocks/_mm-blocks/main-navigation/script";
// import "../../template-parts/blocks/_mm-blocks/main-navigation-dropdown/script";
import "../../template-parts/blocks/_mm-blocks/content-switcher/script";
import "./components/accordion";
// import "./components/video";
import "./components/modal-search";

// Before & After Gallery Slider block
import "./components/bna-gallery-slider";

// blocks
import "../../template-parts/blocks/_mm-blocks/slider/script";
// import "../../template-parts/blocks/video-carousel/script";
import "../../template-parts/blocks/reviews-slider/script";
import "../../template-parts/blocks/home-face/script";
import "../../template-parts/blocks/announcement/script";
import "../../template-parts/blocks/photo-gallery-section/script";
import "../../template-parts/blocks/header/script";
import "../../template-parts/blocks/hero/script";
import "../../template-parts/blocks/doctor-achievements/script";
import "../../template-parts/blocks/_mm-blocks/before-after-comparison/script";
import "../../template-parts/blocks/popup/script";